import React, { useState } from "react";
import Maskbg from "../assets/images/Mask_bg.png";
import { useLocation, useNavigate } from "react-router";

function BottomNav(props) {
  const className =
    props && Object.keys(props).length > 0 ? props.class : "icon-home";
  const [activeTab, setActiveTab] = useState(className);
  const [isAtBottom, setIsAtBottom] = useState(false);
  const navigate = useNavigate();

  window.onscroll = () => {
    const isAtBottom =
      window.innerHeight + window.scrollY + 10 >= document.body.offsetHeight;

    setIsAtBottom(isAtBottom);
  };

  return (
    <div className="bottom-nav">
      <div
        className="nav_img"
        style={{
          borderRadius: isAtBottom
            ? 0
            : window.location.pathname == "/" ||
              window.location.pathname == "/account"
            ? "15px 15px 0 0"
            : 0,
        }}
      >
        <img
          src={Maskbg}
          alt=""
          style={{
            borderRadius: isAtBottom
              ? 0
              : window.location.pathname == "/" ||
                window.location.pathname == "/account"
              ? "15px 15px 0 0"
              : 0,
          }}
        />
        <div className="botton-nav__list">
          <div
            className={`bottom-nav__item ${
              activeTab == "icon-home" ? "active" : ""
            }`}
            onClick={() => {
              setActiveTab("icon-home");
              navigate("/");
            }}
          >
            <div className="icon-home"></div>
            <span>Home</span>
            <div className="line"></div>
          </div>
          <div
            className={`bottom-nav__item ${
              activeTab == "icon-menu" ? "active" : ""
            }`}
            onClick={() => {
              setActiveTab("icon-menu");
              navigate("/menu");
            }}
          >
            <div className="icon-menu"></div>
            <span>Menu</span>
            <div className="line"></div>
          </div>
          <div
            className={`bottom-nav__item ${
              activeTab == "icon-cart" ? "active" : ""
            }`}
            onClick={() => {
              setActiveTab("icon-cart");
              navigate("/cart");
            }}
          >
            <div className="icon-cart"></div>
            <span>Cart</span>
            <div className="line"></div>
          </div>
          <div
            className={`bottom-nav__item ${
              activeTab == "icon-user" ? "active" : ""
            }`}
            onClick={() => {
              setActiveTab("icon-user");
              navigate("/account");
            }}
          >
            <div className="icon-user"></div>
            <span>Account</span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default BottomNav;
